import { jwtDecode } from 'jwt-decode';

const COOKIE_DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN || '.localhost';

export const getToken = () => {
  return localStorage.getItem('accessToken');
};

export const setToken = (token: string) => {
  localStorage.setItem('accessToken', token);
  document.cookie = `accessToken=${token}; path=/; domain=${COOKIE_DOMAIN}; samesite=lax; ${import.meta.env.PROD ? 'secure;' : ''}`;
};

export const clearToken = () => {
  localStorage.removeItem('accessToken');
  document.cookie = 'accessToken=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = `accessToken=; path=/; domain=${COOKIE_DOMAIN}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

export const getRefreshToken = () => {
  return localStorage.getItem('refreshToken');
};

export const setRefreshToken = (token: string) => {
  localStorage.setItem('refreshToken', token);
  document.cookie = `refreshToken=${token}; path=/; domain=${COOKIE_DOMAIN}; samesite=lax; ${import.meta.env.PROD ? 'secure;' : ''}`;
};

export const clearRefreshToken = () => {
  localStorage.removeItem('refreshToken');
  document.cookie = 'refreshToken=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = `refreshToken=; path=/; domain=${COOKIE_DOMAIN}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

export const getCookieToken = (name: string): string | null => {
  const cookies = document.cookie.split(';');
  const tokenCookie = cookies.find(cookie => 
    cookie.trim().startsWith(`${name}=`)
  );
  return tokenCookie ? tokenCookie.split('=')[1] : null;
};

export const syncAuthFromCookie = (): boolean => {
  let synced = false;
  const accessToken = getCookieToken('accessToken');
  if (accessToken && !localStorage.getItem('accessToken')) {
    localStorage.setItem('accessToken', accessToken);
    synced = true;
  }
  const refreshToken = getCookieToken('refreshToken');
  if (refreshToken && !localStorage.getItem('refreshToken')) {
    localStorage.setItem('refreshToken', refreshToken);
    synced = true;
  }
  return synced;
};

export interface UserPayload {
  userId: string;
  username: string;
  role: string;
  exp?: number;
}

export const getUser = (): UserPayload | null => {
  const token = getToken();
  if (!token) return null;
  try {
    return jwtDecode<UserPayload>(token);
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  try {
    const decoded = jwtDecode<UserPayload>(token);
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      clearToken();
      return false;
    }
    return true;
  } catch {
    return false;
  }
};
